import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 100 100"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M0 0v100h100V0zm54.4 49v34l-16.6-5c-1.1-.3-2-1.6-2-2.7V49h-7l20.8-26.2c.7-.9 2.3-1.8 3.4-2.1l18.2-4.4L45.4 49z",
      style: {"fill":"#70b37f"}
    }, null, -1)
  ])))
}
export default { render: render }